import React, { useEffect, useState } from 'react';
import { Segment, Grid, Header, Label } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { ContentData } from './ContentData';
import { getErosketak } from 'volto-ueu/actions';

/**
 * ShopTransferView view component.
 * @module components/Views/OrdainketaView/ShopTransferView
 */
/**
 * ShopTransferView view.
 * @function ShopTransferView
 * @returns {string} Markup of the component.
 */

const ShopTransferView = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const erosketak = useSelector((state) => state.erosketak.erosketak);
  const [erosketa, setErosketa] = useState();
  const subrequests = useSelector((state) => state.search?.subrequests);
  useEffect(() => {
    dispatch(getErosketak());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setErosketa(
      erosketak.filter((erosketa) => erosketa.UID === params.erosketa)[0],
    );
  }, [params.erosketa, erosketak]);
  let title_text = 'Ez da erosketa aurkitu...';
  if (erosketa) {
    title_text = 'Erosketa prozesua martxan da!';
  }
  return (
    <ContentData
      h1_text={title_text}
      Body={() => (
        <>
          {erosketa && (
            <>
              <Segment basic>
                <p>
                  Jaso dugu zure eskaera. Ordainketa egiteko transferentzia
                  aukeratu duzu.
                </p>
                <p>
                  Zure helbide elektronikora bidali dizkizugu erosketaren
                  konfirmazioa eta ordainketa bideratzeko argibideak.
                </p>
                <p>
                  <strong>Adi!</strong> Mezu automatikoa da, baliteke spam edo
                  publizitate karpetara iristea, egiaztatu mezua jaso duzula.
                </p>
              </Segment>
              <Segment basic>Mila esker!</Segment>
            </>
          )}
          {erosketa ? (
            <>
              <Grid className="saski-taula">
                <Grid.Row columns={3}>
                  <Grid.Column width={6}>
                    <strong>Argitalpena</strong>
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <strong>Prezioa</strong>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <strong>Kopurua</strong>
                  </Grid.Column>
                </Grid.Row>
                {erosketa?.saskia?.content &&
                  Object.keys(erosketa?.saskia?.content)?.map((item, key) => (
                    <Grid.Row key={key} columns={3}>
                      <Grid.Column width={6}>
                        {subrequests?.[
                          erosketa?.saskia?.content?.[item]?.publication
                        ]?.items?.[0]?.['@id'] &&
                          `${erosketa?.saskia?.content?.[item]?.title} (${erosketa?.saskia?.content?.[item]?.format})`}
                      </Grid.Column>
                      <Grid.Column width={1}>
                        {`${erosketa?.saskia?.content?.[item]?.unit_price} €`}
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Label basic color="black" className="saskia-count">
                          {erosketa?.saskia?.content?.[item]?.count}
                        </Label>
                      </Grid.Column>
                    </Grid.Row>
                  ))}
              </Grid>
              <Grid className="saski-prezioak">
                <Grid.Row columns={3}>
                  <Grid.Column width={6}></Grid.Column>
                  <Grid.Column width={2}>Subtotala</Grid.Column>
                  <Grid.Column width={3}>
                    {`${erosketa?.saskia.subTotal} €`}
                  </Grid.Column>
                </Grid.Row>
                {erosketa?.saskia.discounts?.length > 0 &&
                  erosketa?.saskia.discounts.map((discount, key) => (
                    <Grid.Row key={key} columns={3}>
                      <Grid.Column width={6}></Grid.Column>
                      <Grid.Column width={2}>{discount.title}</Grid.Column>
                      <Grid.Column
                        width={3}
                      >{`-${discount.value} €`}</Grid.Column>
                    </Grid.Row>
                  ))}
                <Grid.Row columns={3}>
                  <Grid.Column width={6}></Grid.Column>
                  <Grid.Column width={2}>Bidalketa gastuak</Grid.Column>
                  <Grid.Column width={3}>
                    {`${erosketa?.saskia.shipping} €`}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={3}>
                  <Grid.Column width={6}></Grid.Column>
                  <Grid.Column width={2}>
                    <strong>Guztira </strong>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <strong>{`${erosketa?.saskia.total} €`}</strong>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </>
          ) : (
            <Header as="h2">
              Erosketaren helbidea ez dagokio zure erosketa bati
            </Header>
          )}
        </>
      )}
    />
  );
};

export default ShopTransferView;
